import { render, staticRenderFns } from "./ViewPdf.vue?vue&type=template&id=791ab26b"
import script from "./ViewPdf.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewPdf.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports